import React from 'react'
import BiddingContractSubstep from "./BiddingContractSubstep";
import {Img} from "react-image";
import LoadingSpinner from "../../components/LoadingSpinner";
import Form from "../../components/form/Form";
import LoadingBanner from "../../components/LoadingBanner";
import Project from "../../models/Project";
import {CSSTransition} from 'react-transition-group'

export default class BiddingContractApprovalDocumentsSubstep extends BiddingContractSubstep {
    static SubstepName = 'Approve & Start Project';

    static SubstepSlug = 'sign-contract-and-start-project';
    static path = '/sign-contract-and-start-project';

    static StepTitle = 'Review & Sign Contract';


    constructor(props, context) {
        super(props, context);

        this.uploadFormRef = React.createRef();
        this.state = {
            ...this.state,
        }
    }

    async scrollToNode(selector,  delay = undefined, duration = 1000, complete = () => true) {
        const node = $(selector);

        if (node) {
            return $('html, body').animate({scrollTop: $(node).offset().top - 150}, {
                duration, delay, complete
            });
        }
    }
    async uploadAmendedProposal(props) {
        await this.promisedState({isLoading: true, showUploadSuccess: false})
        let response = await this.props.makeRequest(
            () => this.props.project.uploadAmendedSOWProposal(props),
            Project.UploadAmendedSOWProposalRequest
        );

        if (response) {
            this.uploadFormRef.current.forceReset({});

            await this.promisedState({isLoading: false, didUploadForm: true, showUploadForm: false});

            await this.scrollToNode('#latest-revision',300, 1000);

            await TB.wait(800);
            return this.setState({showUploadSuccess: true})
            // return await TB.sysAlert('sow_approval.uploaded_document_revision');
        }

        return this.promisedState({isLoading: false});
    }

    approveFields()
    {
        let user = this.context?.auth;
        if (!user) {
            return null;
        }

        const canCompleteSOWForProject = user.canCompleteSOWForProject(this.props.project),
            canEditSOWForProject = user.canEditSOWForProject(this.props.project);

        let fields = {
            full_name: {
                type: 'text',
                label: false,
                disabled: !canCompleteSOWForProject,
                required: true,
                maxLength: String(this.context?.auth?.fullName()).length,
                placeholder: 'Sign your full name',
                validation: {
                    rules: {
                        matches_auth: ({model}, value) => {
                            if (!value || value !== TB.auth()
                                .user()
                                .fullName()) {
                                return 'Please type your full name: ' + TB.auth()
                                    .user()
                                    .fullName()
                            }

                            return true;
                        }
                    }
                },
                columns: 5
            },
            accept_start_btn: {
                component: (
                    <button
                        type="submit"
                        disabled={this.props.isDisabled}
                        onClick={(e) => {
                            if (!canCompleteSOWForProject) {
                                e.preventDefault();
                                return TB.showPermissionError();
                            }
                        }}
                        className={TB.mapClass('btn btn-primary btn-block', { 'disabled-edit-link': !canCompleteSOWForProject })}
                    >
                        Approve
                        {!canCompleteSOWForProject && (<i className="fa fa-lock ml-1" style={{fontSize: 12}} />)}
                    </button>
                ),
                columns: 4
            },
        };

        return [
            {
                style: {flexDirection: 'row'},
                fields
            }
        ]
    }

    uploadFields() {
        return [
            {
                style: {flexDirection: 'row'},
                fields: {
                    contract: {
                        type: 'file_button',
                        label: false,
                        required: true,
                        accept: '',
                        columns: 4
                    },
                    notes: {
                        type: 'textarea',
                        row: 3,
                        label: false,
                        maxLength: 250,
                        required: true,
                        placeholder: 'Some proposal notes here, kept short',
                        columns: 5
                    },
                    upload_btn: {
                        component: (
                            <button type="submit"
                                    disabled={this.props.isDisabled}
                                    // className="btn btn-outline-white btn-block">
                                    className="btn btn-primary btn-block">

                                {/* Upload Proposal */}
                                Submit Revised Statement of Work
                            </button>
                        ),
                        columns: 3
                    },
                }
            }
        ]
    }

    renderStepTitle() {
        const canRequestSOWForProject = this.context?.auth?.canRequestSOWForProject(this.props.project);

        return (
            <div className="flex-center-row w-full justify-between">
                <h3>
                    {this.constructor.StepTitle}
                </h3>

                {!this.props.project.isAwaitingKickoff() && !this.props.project.hasUploadedManualContract() && (
                    <button
                        onClick={() => {
                            if (!canRequestSOWForProject) {
                                return TB.showPermissionError();
                            }
                            this.props.cancelProjectSOWApproval()
                        }}
                        className={TB.mapClass('btn btn-outline-primary sow-cancel-approval-btn ml-auto', { 'disabled-edit-link': !canRequestSOWForProject })}
                    >
                        <span><b> Cancel Signature</b>
                            {!canRequestSOWForProject && (<i className="fa fa-lock ml-1"/>)}
                            </span>
                        <span>Go back to SoW Approval Steps</span>
                    </button>
                )}

            </div>
        )
    }


    renderStepContent() {
        let {project, isDisabled} = this.props;

        let documents = project.sowDocumentsAndRevisions()

        let lastRevisionContract = TB.findLast(documents, doc => doc.isTypeClientRevisedProposal());

        return (
            <div className="sow-approval-documents-step">

                {isDisabled && (
                    <div className="flex-center-column">
                        <LoadingBanner/>
                    </div>
                )}

                {!isDisabled && (
                    project.hasUploadedManualContract() ? this.renderManualContractRow() :
                        documents.map((sowDocument, index) => {

                            let typeWrippleContract = sowDocument.isTypeContract() || sowDocument.isTypeGeneratedContract();
                            let typeRevision = sowDocument.isTypeClientRevisedProposal();
                            let isLatestContract = sowDocument.id === project.latestContract()?.id;
                            let isLatestUploadedRevision = typeRevision && sowDocument.id === lastRevisionContract?.id && this.state.didUploadForm;

                            return (
                                <React.Fragment key={sowDocument.id}>
                                    {typeWrippleContract && this.renderSOWRow(sowDocument, index, isLatestContract)}
                                    {typeRevision && this.renderRevisionRow(sowDocument, index, isLatestUploadedRevision)}
                                    {isLatestContract && this.state.showUploadForm && this.renderUploadRevisionForm(index)}
                                </React.Fragment>
                            )
                        })
                )}
            </div>
        );
    }


    renderSOWRow(sowDocument, index, isLatestContract) {
        let user = this.context?.auth;
        if (!user) {
            return null;
        }

        let documents = this.props.project?.sowDocumentsAndRevisions()

        // should hide button if last document is a pending proposal
        const canEditSOWForProject = user.canEditSOWForProject(this.props.project);

        return (
            <div className={TB.mapClass("sow-document-item typeContract", {
                'replaced-contract': !isLatestContract
            })}>

                <div className="sow-document-owner">
                    <Img
                        loader={(<div className="img-fluid img-loader">
                                <LoadingSpinner/>
                            </div>
                        )}
                        src={[TB.logoImagePath()]}
                        className="img-fluid"
                    />

                    {(index < (documents.length - 1) || (isLatestContract && this.state.showUploadForm)) && (
                        <div className="sow-document-divider">
                            <div className="divider-line"/>
                        </div>
                    )}
                </div>

                <div className="sow-document-row">


                    <table className="table table-borderless sow-document-details">
                        <tbody>
                        <tr>

                            <td style={{width: 165}} className="doc-type-name">
                                <p className="text-primary mb-2">
                                Statement of Work

                                </p>
                                <button
                                    onClick={() => window.open(sowDocument.path, '_blank').focus()}
                                    className="btn btn-outline-white download-doc-btn">
                                    <i className="far fa-file-alt"/>
                                    Download
                                </button>

                            </td>

                            <td style={{width: 100}} className="doc-uploaded-at">
                                {TB.moment(sowDocument.uploaded_at).format('MM/DD/YYYY')}
                            </td>

                            <td style={{width: '45%'}}>
                                <div className="doc-notes">
                                    <span>{sowDocument.notes}</span>
                                </div>
                            </td>

                            <td style={{width: 120}}>

                            </td>
                        </tr>
                        </tbody>

                    </table>

                    {!isLatestContract ? (
                        <div className="sow-contract-newer-version">

                            <div>

                                <p className="mb-0">
                                    This Statement of Work has been replaced by a newer version
                                </p>
                                {!this.props.project.isAwaitingKickoff() && (
                                    <button className="btn btn-link btn-link-primary" onClick={() => {

                                        const node = $('.wripple-form input[name="full_name"]')

                                        return this.scrollToNode(
                                            '.wripple-form input[name="full_name"]',
                                            0,
                                            1000,
                                            () => node.focus()
                                        )
                                    }}>
                                        Please sign the latest version
                                    </button>
                                )}
                            </div>

                        </div>
                    ) : (
                        <>

                            {this.renderSignContractForm()}

                            {!this.props.project.isAwaitingKickoff() && !this.state.showUploadForm && (
                                <div className="text-left" style={{paddingLeft: 15}}>
                                    <p style={{fontSize: 12}} className="mb-0 font-weight-bold">Want to modify the
                                        Statement Of Work above?</p>
                                    <button
                                        type="button"
                                        onClick={async() => {
                                            if (!canEditSOWForProject) {
                                                return TB.showPermissionError();
                                            }

                                            await this.promisedState({showUploadForm: true});
                                            return this.scrollToNode('#revision-upload-form')
                                        }}
                                        disabled={this.props.isDisabled}
                                        style={{padding: 0}}
                                        className={TB.mapClass('btn btn-link btn-link-primary', { 'disabled-edit-link': !canEditSOWForProject })}
                                    >
                                        Propose Revision
                                        {!canEditSOWForProject && (<i className="fa fa-lock ml-1" style={{fontSize: 12}} />)}
                                    </button>
                                </div>
                            )}

                        </>
                    )}
                </div>
            </div>
        )
    }

    renderManualContractRow() {

        let manualContract = this.props.project?.latestContract();

        return (
            <div className="sow-document-item typeContract">

                <div className="sow-document-owner">
                    <Img
                        loader={(<div className="img-fluid img-loader">
                                <LoadingSpinner/>
                            </div>
                        )}
                        src={[TB.logoImagePath()]}
                        className="img-fluid"
                    />
                </div>

                <div className="sow-document-row">


                    <table className="table table-borderless sow-document-details">
                        <tbody>
                        <tr>

                            <td style={{width: 165}} className="doc-type-name">
                                <p className="text-primary mb-2">
                                    Statement of Work
                                </p>
                                <button
                                    onClick={() => window.open(manualContract.path, '_blank').focus()}
                                    className="btn btn-outline-white download-doc-btn">
                                    <i className="far fa-file-alt"/>
                                    Download
                                </button>

                            </td>

                            <td style={{width: 100}} className="doc-uploaded-at">
                                {TB.moment(manualContract.uploaded_at).format('MM/DD/YYYY')}
                            </td>

                            <td style={{width: 120}}>
                                {/* <button
                                    onClick={() => window.open(sowDocument.path, '_blank').focus()}
                                    className="btn btn-outline-white download-doc-btn">
                                    <i className="far fa-file-alt"/>
                                    Download
                                </button> */}
                            </td>
                        </tr>
                        </tbody>

                    </table>

                    {this.renderSignContractForm()}

                </div>
            </div>
        )
    }

    renderSignContractForm() {
        if (this.props.project.isAwaitingKickoff()) {
            return this.props.project.client_contract_signed_at ? (
                <div className="sow-contract-approval-forms">
                    <p className="mb-1">
                        <b>Approved & Signed:</b> {TB.moment(this.props.project.client_contract_signed_at).format('LLLL')}
                    </p>
                </div>
            ) : <div/>
        }


        return (
            <div className="sow-contract-approval-forms">

                <div>
                    <p className="mb-1">
                        <b>Ready to Sign</b>
                    </p>
                    <p className="mb-1">
                        Review, approve and start the project by signing your name below.
                    </p>
                    <Form
                        className="sow-contract-approval-confirm"
                        submitButton={false}
                        background={'transparent'}
                        isDisabled={this.props.isDisabled || this.state.isLoading}
                        onSubmit={this.props.startProject}
                        fields={this.approveFields()}
                    />
                </div>
            </div>
        )
    }

    renderRevisionRow(sowDocument, index, isLatestUploadedRevision) {

        let documents = this.props.project?.sowDocumentsAndRevisions()

        return (
            <div className="sow-document-item typeRevision"
                 id={isLatestUploadedRevision ? 'latest-revision' : undefined}>

                <div className="sow-document-owner">
                    <Img
                        loader={(
                            <div className="img-fluid img-loader">
                                <LoadingSpinner/>
                            </div>
                        )}
                        src={[this.context?.auth?.clientOrg?.().logo_path, TB.logoImagePath()]}
                        className="img-fluid"
                    />

                    {index < (documents.length - 1) && (
                        <div className="sow-document-divider">
                            <div className="divider-line"/>
                        </div>
                    )}
                </div>

                <div className="sow-document-row">
                    <table className="table table-borderless sow-document-details">
                        <tbody>
                        <tr>

                            <td className="text-left">
                                {sowDocument.causer ? (
                                    <span>Revised Proposal uploaded by <b>{sowDocument.causer?.name}</b> on {TB.moment(sowDocument.uploaded_at)
                                        .format('MM/DD/YYYY')}</span>
                                ) : (
                                    <span>Revised Proposal uploaded on <b>{TB.moment(sowDocument.uploaded_at)
                                        .format('MM/DD/YYYY')}</b></span>
                                )}
                                <button
                                    onClick={() => window.open(sowDocument.path, '_blank').focus()}
                                    className="btn btn-link btn-link-primary mx-2">
                                    Download Revision
                                </button>
                            </td>
                        </tr>
                        <tr>

                            <td className="text-left">
                                <b>Notes:</b> {sowDocument.notes}
                            </td>
                        </tr>
                        </tbody>

                    </table>

                    {isLatestUploadedRevision && (
                        <div style={{minHeight: 80}}>
                            <CSSTransition
                                in={this.state.showUploadSuccess}
                                classNames="fade"
                                unmountOnExit={true}
                            >
                                <div className="sow-contract-newer-version">

                                    <div>

                                        <p className="mb-0 text-secondary">
                                            Thank you, we will reach out within 24 hours with an update. Once we have reviewed and accepted your revisions, you will be able sign here. In the meantime, if you decide to accept the version above, you can type your name at any time to move forward.
                                        </p>
                                    </div>

                                </div>

                            </CSSTransition>

                        </div>
                    )}
                </div>
            </div>
        )
    }

    renderUploadRevisionForm(index) {
        let documents = this.props.project?.sowDocumentsAndRevisions();

        return (
            <div className="sow-document-item typeContract" id="revision-upload-form">

                <div className="sow-document-owner">
                    <Img
                        loader={(
                            <div className="img-fluid img-loader">
                                <LoadingSpinner/>
                            </div>
                        )}
                        src={[this.context?.auth?.clientOrg?.().logo_path, TB.logoImagePath()]}
                        className="img-fluid"
                    />

                    {index < (documents.length - 1) && (
                        <div className="sow-document-divider">
                            <div className="divider-line"/>
                        </div>
                    )}
                </div>
                <div className="sow-document-row">
                    <div className="sow-contract-approval-forms">
                        <div>
                            <p>
                                Add a marked up PDF proposal for us to review
                            </p>
                        </div>

                        <Form
                            ref={this.uploadFormRef}
                            className="sow-upload-revision"
                            submitButton={false}
                            background={'transparent'}
                            isDisabled={this.props.isDisabled || this.state.isLoading}
                            onSubmit={props => this.uploadAmendedProposal(props)}
                            fields={this.uploadFields()}
                        />
                    </div>
                </div>
            </div>
        )
    }
}